module.exports = __webpack_public_path__ + "img/logo-name.c4ce62ee.png";